<template>
  <Card class="pa-4">
    <FlexColumn>
      <Label size="h6" bold text="学歴" />
      <FlexColumn class="properties">
        <FlexColumn v-if="academicHistory">
          <Label text="最終学歴"/>
          <Label bold :text="academicHistory" />
        </FlexColumn>
        <FlexColumn v-if="academicHistory">
          <Label text="学校名"/>
          <FlexRow wrap class="academic-block" space="0">
            <FlexRow v-if="applicant.academic.schoolName">
              <Label bold :text="applicant.academic.schoolName" />
            </FlexRow>
            <FlexRow v-if="applicant.academic.schoolDepartment">
              <Label bold :text="applicant.academic.schoolDepartment"/>
            </FlexRow>
            <FlexRow v-if="applicant.academic.schoolDepartmentDetail">
              <Label bold :text="applicant.academic.schoolDepartmentDetail"/>
            </FlexRow>
            <FlexRow v-if="applicant.academic.graduatedYear" space="0">
              <Label bold :text="applicant.academic.graduatedYear" />
              <Label text="年卒"/>
              <Label v-if="isFuture(applicant.academic.graduatedYear)" text="予定"/>
            </FlexRow>
          </FlexRow>
        </FlexColumn>
      </FlexColumn>
    </FlexColumn>
  </Card>
</template>

<script>
import Card from "@/components/atoms/Card";
import FlexColumn from "@/components/atoms/FlexColumn";
import Label from "@/components/atoms/Label";
import {mapGetters} from "vuex";
import ComponentMixin from "@/components/ComponentMixin";
import FlexRow from "../atoms/FlexRow.vue";

export default {
  mixins: [ComponentMixin],
  name: "ApplicantAcademicCard",
  components: {FlexRow, Label, FlexColumn, Card},
  props: {
    applicant: {
      type: Object
    }
  },
  computed: {
    ...mapGetters("system", ["consts"]),
    academicHistory() {
      return this.constsToText(this.applicant.academic.academicHistory, this.consts.academics)
    },
  },
  methods: {
    isFuture(year) {
      const date = new Date()
      return year >= date.getFullYear()
    }
  }
}
</script>

<style scoped>
.properties > *:not(:last-child) {
  border-bottom: rgba(0, 0, 0, 0.12) solid thin;
  margin-bottom: 8px;
  padding-bottom: 8px;
}
.academic-block > *:not(:last-child):after {
  margin-right: 4px;
  content: " "
}
</style>
